import { Box, Checkbox, MenuItem, Text } from '@chakra-ui/react';

export function VirtualFilterItem({
  virtualRow,
  item,
  measureElement,
  selectedItems,
  onCheckboxChange,
  isAtLimit = false,
}: {
  virtualRow: {
    index: number;
  };
  item:
    | {
        id: string;
        value: string;
        label: string;
        element?: React.ReactElement;
      }
    | undefined;
  measureElement: (element: HTMLElement | null) => void;
  selectedItems: string[];
  onCheckboxChange: (id: string) => void;
  isAtLimit?: boolean;
}) {
  if (!item) {
    return null;
  }

  const isSelected = selectedItems.includes(item.id);
  // At the limit, unselected items are disabled so the user can't go over.
  // Selected items remain interactive so they can be deselected.
  const isDisabled = isAtLimit && !isSelected;

  return (
    <Box data-index={virtualRow.index} ref={measureElement}>
      <MenuItem
        onClick={isDisabled ? undefined : () => onCheckboxChange(item.id)}
        isDisabled={isDisabled}
        display="flex"
        alignItems="center"
      >
        <Checkbox
          isChecked={isSelected}
          isDisabled={isDisabled}
          onChange={isDisabled ? undefined : () => onCheckboxChange(item.id)}
          mr={2}
        />

        {item.element ? (
          item.element
        ) : (
          <Text fontSize="sm" as={'span'}>
            {(item as { label: string })?.label}
          </Text>
        )}
      </MenuItem>
    </Box>
  );
}
